/* eslint-disable camelcase */
export default {
	//
	// DiscProfileHeader
	//
	DiscProfileHeader__headerLinkDescription: "Opre’s work style reports use the DiSC personality assessment.",
	DiscProfileHeader__headerLinkText: "Learn more about DiSC.",

	//
	// AssessmentPrompt
	//
	AssessmentPrompt__headerLinkDescription: "Opre’s work style reports use the DiSC personality assessment.",
	AssessmentPrompt__headerLinkText: "Learn more about DiSC.",

	TendencyCharacteristics__heading: "Tendencies",
	BehaviorCharacteristics__heading: "Natural behaviors",
	StrengthCharacteristics__heading: "Strengths",
	ChallengeCharacteristics__heading: "Challenges",
	MeetingCharacteristics__heading: "Meeting",
	CommunicationCharacteristics__heading: "Communicating",
	CollaborationCharacteristics__heading: "Collaborating",
	PersuasionCharacteristics__heading: "Persuading",
	DrivenCharacteristics__heading: "Driven by",
	InfluenceCharacteristics__heading: "Asserts influence through",
	EnergizingCharacteristics__heading: "Energizers",
	DrainingCharacteristics__heading: "Drainers",
	GreatLeaderCharacteristics__heading: "What makes you a great leader",
	BetterLeaderCharacteristics__heading: "How might you become a better leader?",
	LeadershipStrengthCharacteristics__heading: "Leadership Strengths",
	LeadershipChallengeCharacteristics__heading: "Leadership challenges",
};
